import React, { Component, useRef, useState, useEffect } from 'react';
import {Link, useParams } from "react-router-dom";
import NavBarMini from './NavBarMini.js';
import Footer from './Footer.js';
import LoadingAnimation from './LoadingAnimation.js';
import * as utils from '../common/Utils.js'
import { useConfig } from '../contexts/ConfigContext.js';

import { collection, query, where, getDoc, getDocs, setDoc, addDoc, updateDoc, doc, Timestamp, collectionGroup } from "firebase/firestore";
import { db } from '../firebase.js';

const Records = () => {  
  const [players, setPlayers] = useState([])
  const [allGameStats, setAllGameStats] = useState([])

  const [dataReady, setDataReady] = useState(false);

  useEffect(() => {
    getLeague();
  }, [])

  const getLeague = async () => {
    const gameStatsCollectionRef = collection(db, "gameStats");
    const gameStatsSnapshot = await getDocs(gameStatsCollectionRef);
    const allGameStats = [];
    gameStatsSnapshot.forEach(doc => {
      let stats = doc.data()['stats'] || [];
      allGameStats.push(...stats);
    });

    await setAllGameStats(allGameStats)

    const playerSnapshot = await getDocs(collection(db, 'players'));
    const players = playerSnapshot.docs.map((doc) => doc.data());

    setPlayers(players)

    setDataReady(true);
  }

  function showTotalStatRow(player, stat) {
    let statLabelAbbv = {
      'assists': 'AST',
      'points': 'PTS',
      'rebounds': 'REB',
      'steals': 'STL',
      'blocks': 'BLK',
    }
    let avgStatLabelAbbv = {
      'assists': 'APG',
      'points': 'PPG',
      'rebounds': 'RPG',
      'steals': 'SPG',
      'blocks': 'BPG',
    }
    let p = utils.getPlayerByID(players, player.playerID)
    return (
      <div className='league-game-player-stat-group'>
        <p className='league-game-player-name' key={player.playerID + '-player-name'}><span className='league-total-stat-place'>{ player.place }</span> <a className="unstyled-link" href={"/players/" + player.playerID }>{ utils.displayPlayerName(p) }</a></p>
        <p className='league-game-player-stat' key={player.playerID + '-player-stat'}>{ player.total } <span className='league-season-average-label'>{ statLabelAbbv[stat] }</span> <span className='league-season-average-label'>({ parseFloat(player.average.toFixed(1)) } { avgStatLabelAbbv[stat] })</span></p>
      </div>
    )
  }

  function getStatsForPlayer (playerID, withStealsAndBlocks) {
    let allStatsForPlayer;
    if (withStealsAndBlocks) {
      allStatsForPlayer = allGameStats.filter((gameStat) => gameStat.playerID == playerID && gameStat.status == 'played' && gameStat.blocks !== undefined)
    } else {
      allStatsForPlayer = allGameStats.filter((gameStat) => gameStat.playerID == playerID && gameStat.status == 'played')
    }

    return allStatsForPlayer;
  }

  function showTopStats (stat) {
    let playerTotals = []

    players.forEach((p) => {
      let allStatsForPlayer;
      if (stat == 'blocks' || stat == 'steals') {
        allStatsForPlayer = getStatsForPlayer(p.id, true);
      } else {
        allStatsForPlayer = getStatsForPlayer(p.id, false);
      }

      if (allStatsForPlayer.length == 0) {
        return;
      }

      let total = allStatsForPlayer.reduce(function (tot, player, _) {
        return tot + player[stat];
      }, 0);

      let average = allStatsForPlayer.reduce(function (avg, player, _, { length }) {
        return avg + player[stat] / length;
      }, 0);

      let playerTotal = {
        'playerID': p.id,
        'name': utils.displayPlayerName(p),
        'total': total,
        'average': average,
        'games': allStatsForPlayer.length
      }
      playerTotals.push(playerTotal)
    })

    let topThreePlayerTotals = playerTotals.sort((function(a,b){
      return a.total > b.total ? -1 : 1;
    })).slice(0, 3);

    let topFivePlayerTotals = playerTotals.sort((function(a,b){
      return a.total > b.total ? -1 : 1;
    })).slice(0, 5);

    let topTenPlayerTotals = playerTotals.sort((function(a,b){
      return a.total > b.total ? -1 : 1;
    })).slice(0, 10);

    let topTwentyPlayerTotals = playerTotals.sort((function(a,b){
      return a.total > b.total ? -1 : 1;
    })).slice(0, 20);

    let statLabel = {
      'assists': 'Assists',
      'points': 'Points',
      'rebounds': 'Rebounds',
      'steals': 'Steals',
      'blocks': 'Blocks',
    }

    // let topPlayerTotals = topThreePlayerTotals;
    // let topPlayerTotals = topFivePlayerTotals;
    // let topPlayerTotals = topTenPlayerTotals;
    let topPlayerTotals = topTwentyPlayerTotals;

    topPlayerTotals = addPlaceToTotals(topPlayerTotals)

    if (topPlayerTotals.length == 0) {
      return;
    } else {
      return (
        <div className='league-player-display'>
          <p className="league-title-standard-small text-center"><b>{ statLabel[stat] }</b></p>
          <div className='league-player-container'>
            <div className='league-game-player-stats'>
              { topPlayerTotals.map((player) => showTotalStatRow(player, stat) ) }
            </div>
          </div>
        </div>
      )
    }
  }

  function addPlaceToTotals(topPlayerTotals) {
    for(let i = 0; i < topPlayerTotals.length; i++) {
      let p = topPlayerTotals[i]
      let place = (i + 1).toString()

      if (i == 0) {
        let pa = topPlayerTotals[i+1]

        if (p.total == pa.total) {
          p.place = `T${place}`
        } else {
          p.place = place
        }
      } else if (i == topPlayerTotals.length - 1) {
        let pb = topPlayerTotals[i-1]

        if (p.total == pb.total) {
          p.place = pb.place
        } else {
          p.place = place
        }
      } else {
        let pb = topPlayerTotals[i-1]
        let pa = topPlayerTotals[i+1]

        if (p.total == pb.total) {
          p.place = pb.place
        } else if (p.total == pa.total) {
          p.place = `T${place}`
        } else {
          p.place = place
        }
      }
    }

    return topPlayerTotals;
  }

  if (dataReady == false) {
    return (
      <div className="Schedule">
        <LoadingAnimation />
      </div>
    )
  }
  else {
    return (
      <div className="Schedule">
        <div className="league-content">

          <div className="league-body">
            <div className='league-records'>
              <div className="league-game-stats-container">
                  <p className="league-title-skinny-medium"><b>All-Time Leaders</b></p>
                  { showTopStats('points') }
                  { showTopStats('rebounds') }
                  { showTopStats('assists') }
                  { showTopStats('steals') }
                  { showTopStats('blocks') }
                </div>
              </div>
            </div>
        </div>

        <Footer/>
      </div>
    );
  }
}

export default Records;
